import { SOFToolBrowseFilter } from '@models/interfaces';

export const SOF_TOOL_BROWSE_DEFAULT_CONFIGURE_FILTER: SOFToolBrowseFilter = {
  PSLocationCode: undefined,
  siteName: undefined,
  fuzeId: undefined,
  SS014ActualDate: undefined,
};
